import React, { Component } from "react"
import PropTypes from "prop-types"
import { LayeredBackgroundImage, ImageDisclaimer } from "containers"
import { InteriorSelector, Heading } from "components"
import { withRadium, DetectCompact, gtmEvent } from "higher-order-components"
import { gtmBackgroundImageSelectorActionTypes } from "store/gtm-events"

/** Background Image Selector Component */
class BackgroundImageSelector extends Component {
  constructor(props) {
    super(props)
    this.state = {
      active: 0
    }
  }
  static propTypes = {
    heading: PropTypes.string,
    mobileHeading: PropTypes.string,
    options: PropTypes.array.isRequired,
    description: PropTypes.string,
    type: PropTypes.string.isRequired,
    gtm: PropTypes.object,
    gtmEvent: PropTypes.func,
    compact: PropTypes.bool
  }

  componentDidMount() {
    this.setState({
      active: this.props.initialActiveIndex || 0
    })
  }

  handleChange = (option) => {
    const { gtm, gtmEvent } = this.props
    gtmEvent({
      gtmID: gtmBackgroundImageSelectorActionTypes.CLICK_IMAGE,
      gtmPayload: {
        CMSGroupGTM: gtm,
        imageName: option.name
      }
    })
    this.setState({ active: this.props.options.indexOf(option) })
  }
  /**
   * @param {String} [heading] - Heading text.
   * @param {String} [mobileHeading] - Mobile Heading text.
   * @param {Array|BackgroundImageSelectorOption} options - Array of options.
   * @param {String} type - Radio Group Type ('interior, exterior, technology').
   * @returns {ReactElement} React Component
   */
  render() {
    const {
      description, heading, mobileHeading = heading, options, type, compact
    } = this.props
    const { active } = this.state
    return (
      <div style={styles.wrapper}>
        {heading && (
          <Heading tag="h3" textAlign={"center"} value={compact ? mobileHeading : heading} />
        )}
        {description && (
          <div style={styles.description} dangerouslySetInnerHTML={{ __html: description }} />
        )}
        {options.length > 0 && (
          <div>
            <div style={styles.selector}>
              <InteriorSelector
                showActiveLabel={this.props.compact}
                options={options}
                padding={compact ? "0.5em 1em 0.2em" : "10px 0 20px"}
                active={active}
                onChange={this.handleChange}
                type={type}
                labelCustomStyle={{ padding: "1em .3em" }} />
            </div>
            <div style={styles.base}>
              <LayeredBackgroundImage imageSrc={options[active].src} />
              {options[active].disclaimer && (
                <ImageDisclaimer content={options[active].disclaimer} />
              )}
            </div>
          </div>
        )}
      </div>
    )
  }
}

BackgroundImageSelector.propTypes = {
  compact: PropTypes.bool,
  initialActiveIndex: PropTypes.number,
  gtm: PropTypes.object,
  gtmEvent: PropTypes.func
}

export default withRadium(DetectCompact(), gtmEvent())(BackgroundImageSelector)

const styles = {
  wrapper: {
    textAlign: "center",
    margin: 0
  },
  base: {
    position: "relative",
    color: "white",
    maxWidth: "1200px",
    width: "90vw",
    margin: "0 auto",
    userSelect: "none"
  },
  selector: {
    padding: "0",
    textAlign: "center"
    // margin: '2em 0 0' Padding is removed for SM-1357
  },
  description: {
    fontWeight: "200",
    fontSize: "100%",
    lineHeight: "1.6",
    margin: "1.5em 0",
    letterSpacing: "0.01em"
  }
}

/**
 * @typedef {Object} BackgroundImageSelectorOption
 * @property {String} slug - Option Slug
 * @property {String} name - Option Name/Value
 * @property {URL} src - Image URL
 * @property {URL} icon - Icon URL
 * @property {String} [disclaimer] - Disclaimer Text
 */



// WEBPACK FOOTER //
// ./src/containers/background-image-selector/index.jsx